import { render, staticRenderFns } from "./TeamModalComponent.vue?vue&type=template&id=57d24f53&scoped=true&"
import script from "./TeamModalComponent.vue?vue&type=script&lang=js&"
export * from "./TeamModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d24f53",
  null
  
)

export default component.exports